// invoke-callback.ts — kanonischer Aufruf eines optionalen Consumer-Callbacks,
// dessen RÜCKGABE die WC NICHT braucht (fire-and-forget). ÜBERALL, wo eine WC so
// einen Callback annimmt (onSearch, onChange, onClick, …), gilt damit einheitlich:
// synchrone UND asynchrone (Promise) Funktionen sind gleichermaßen erlaubt.
// Ein rejectetes Promise oder ein synchroner Wurf des Consumers wird geschluckt
// (ein Consumer-Fehler darf die WC nicht mitreißen).
//
// NICHT für Callbacks nutzen, deren Rückgabe den Ablauf steuert (z. B. modal-
// Action → DialogResult, confirmDialog.onConfirm) — die werden direkt awaited.
export function invokeCallback<A extends unknown[]>(
  fn: ((...args: A) => unknown) | undefined | null,
  ...args: A
): void {
  if (typeof fn !== "function") return;
  try {
    void Promise.resolve(fn(...args)).catch(() => {});
  } catch {
    /* synchroner Consumer-Fehler ignorieren */
  }
}
